     // This script is wrapped in a DOMContentLoaded event listener.
        // This ensures that the HTML document is fully loaded and parsed before the script runs,
        // preventing errors from trying to select elements that don't exist yet.
        // This makes the code safe to place in an external .js file.
        document.addEventListener('DOMContentLoaded', function() {
            const menuTriggers = document.querySelectorAll('.has-mega-menu');
            
            // This part of the script handles the click-to-open functionality on touch devices.
            menuTriggers.forEach(trigger => {
                const link = trigger.querySelector('a');
                if (link) {
                    link.addEventListener('click', function(e) {
                        // On smaller screens, prevent the link from navigating so we can show the menu.
                        if (window.innerWidth < 1024) { // This is the 'lg' breakpoint.
                            e.preventDefault();
                            const megaMenu = trigger.querySelector('.mega-menu');
                            if (megaMenu) {
                                // Toggle the display of the clicked mega menu.
                                if (megaMenu.style.display === 'block') {
                                    megaMenu.style.display = 'none';
                                } else {
                                    // First, hide any other open mega menus.
                                    document.querySelectorAll('.mega-menu').forEach(m => {
                                        m.style.display = 'none';
                                    });
                                    // Then, show the clicked one.
                                    megaMenu.style.display = 'block';
                                }
                            }
                        }
                    });
                }
            });
        });